////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, reject, findIndex, map, includes } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'
import { uriList } from '../../routings/settings/RouteList'

extendUpdate(update)

const rolesManager = {
	[ActionsTypes.GET_ROLES]: (state) =>
		update(state, {
			rolesManager: {
				isLoading: {
					$set: true,
				},
				roleDetail: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_ROLES_SUCCESS]: (state, payload) => {
		map(payload.roles, (elem) => {
			elem.isPrivate = !elem.public
			return elem
		})
		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.roles,
				},
			},
		})
	},
	[ActionsTypes.GET_ROLES_FAILURE]: (state, payload) =>
		update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.CREATE_ROLE]: (state) =>
		update(state, {
			rolesManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CREATE_ROLE_SUCCESS]: (state, payload) => {
		let rolesList = cloneDeep(state.rolesManager.items)

		payload.role.isPrivate = !payload.role.public

		rolesList.push(payload.role)

		// Check if we were in role manager modal
		// Getting the roles in userDetail
		let userDetailRoleList = cloneDeep(state.userDetail.items)

		if (includes(window.location.pathname, uriList.usersManagerEdit) || includes(window.location.pathname, uriList.usersManagerCreate)) {
			// We need to find the right company which need update on roles...
			const f = findIndex(userDetailRoleList.advailableCompanies, { id: userDetailRoleList.userCompany.id })
			userDetailRoleList.advailableCompanies[f].roles.push(payload.role)
		}

		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: rolesList,
				},
				roleDetail: {
					$set: false,
				},
			},
			userDetail: {
				items: {
					$set: userDetailRoleList,
				},
			},
		})
	},
	[ActionsTypes.CREATE_ROLE_FAILURE]: (state, payload) => {
		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.DELETE_ROLE]: (state) =>
		update(state, {
			rolesManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.DELETE_ROLE_SUCCESS]: (state, payload) => {
		let oldRoles = cloneDeep(state.rolesManager.items)
		const idRole = payload.idRole
		oldRoles = reject(oldRoles, { id: idRole })

		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: [...oldRoles],
				},
				error: {
					$set: false,
				},
				deleteSuccess: {
					$set: true,
				},
				roleDetail: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.DELETE_ROLE_FAILURE]: (state, payload) => {
		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.GET_ROLE_DETAIL]: (state) =>
		update(state, {
			rolesManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				roleDetail: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_ROLE_DETAIL_SUCCESS]: (state, payload) => {
		const trl = state.languages.translations
		// Patch : we take authorizations from roles list, not from payload
		// If we are in user mode, we cannot edit/delete current roles, only new ones
		let role = cloneDeep(payload.roleDetail)

		let rolesList = cloneDeep(state.rolesManager.items)
		const ind = findIndex(rolesList, { id: role.role.id })

		const roleFound = cloneDeep(rolesList[ind])
		role.role.canBeModify = roleFound.canBeModify
		role.role.canBeDelete = roleFound.canBeDelete

		// Remap of user name => we add also his current role and companytyped
		map(role.users, (elem) => {
			elem.fullName = `${elem.fullName} (${elem.role.translationKey} - ${trl[elem.companyTypedName.translationKey]})`
		})
		role['new'] = true

		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				roleDetail: {
					$set: role,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_ROLE_DETAIL_FAILURE]: (state, payload) =>
		update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.UPDATE_HEADER_ROLE]: (state) =>
		update(state, {
			rolesManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_HEADER_ROLE_SUCCESS]: (state, payload) => {
		payload.role.isPrivate = !payload.role.public

		let role = cloneDeep(payload.role)
		let rolesList = cloneDeep(state.rolesManager.items)
		const ind = findIndex(rolesList, { id: role.id })

		rolesList.splice(ind, 1, role)

		let roleDetail = cloneDeep(state.rolesManager.roleDetail)
		if (roleDetail.role.id === role.id) {
			//roleDetail.role.translationKey = role.translationKey
			roleDetail.role.label = role.label
			roleDetail.role.level = role.level
		}

		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: rolesList,
				},
				roleDetail: {
					$set: roleDetail,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_HEADER_ROLE_FAILURE]: (state, payload) => {
		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_CONTENT_ROLE]: (state) =>
		update(state, {
			rolesManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_CONTENT_ROLE_SUCCESS]: (state, payload) => {
		let role = cloneDeep(payload.role)
		let rolesList = cloneDeep(state.rolesManager.items)
		const ind = findIndex(rolesList, { id: role.id })

		rolesList[ind] = role

		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: rolesList,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_CONTENT_ROLE_FAILURE]: (state, payload) => {
		return update(state, {
			rolesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.RESET_ROLE]: (state) => {
		return update(state, {
			rolesManager: {
				roleDetail: {
					$set: false,
				},
				items: {
					$set: [],
				},
			},
		})
	},
}

export default rolesManager
